"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("./utils");
var projectTypeInput_1 = require("./projectTypeInput");
var validations_1 = require("./validations");
var formatter_1 = require("../../../helpers/formatter");
var index_1 = require("../components/inputs/index");
var index_2 = require("../components/layout/index");
var _ = require("lodash");
var ProjectWorklogs = /** @class */ (function (_super) {
    __extends(ProjectWorklogs, _super);
    function ProjectWorklogs(newProps) {
        var _this = _super.call(this, newProps) || this;
        _this.state = { expanded: true };
        return _this;
    }
    ProjectWorklogs.prototype.renderSummary = function (projectHours) {
        var workError = (0, validations_1.isCorrespondsHours)(projectHours.work, this.props.totalWorkTime);
        var travelError = (0, validations_1.isCorrespondsHours)(projectHours.travel, this.props.totalTravelTime);
        var workClasses = (0, classnames_1.default)({ error: workError, green: !workError });
        var travelClasses = (0, classnames_1.default)({ error: travelError, green: !travelError });
        return (React.createElement("tbody", { className: "project-summary" },
            React.createElement("tr", null,
                React.createElement("td", { className: "type-column green" }, "Totaal gewerkt"),
                React.createElement("td", null, formatter_1.Hour.durationToHourMinuteString(projectHours.work.hours)),
                React.createElement("td", null, formatter_1.Hour.durationToHourMinuteString(this.props.totalWorkTime)),
                React.createElement("td", { className: workClasses }, formatter_1.Hour.durationToHourMinuteString(projectHours.work.approvedHours))),
            React.createElement("tr", null,
                React.createElement("td", { className: "type-column green" }, "Totaal reistijd"),
                React.createElement("td", null, formatter_1.Hour.durationToHourMinuteString(projectHours.travel.hours)),
                React.createElement("td", null, formatter_1.Hour.durationToHourMinuteString(this.props.totalTravelTime)),
                React.createElement("td", { className: travelClasses }, formatter_1.Hour.durationToHourMinuteString(projectHours.travel.approvedHours)))));
    };
    ProjectWorklogs.prototype.worklogOnChange = function (target, worklog) {
        this.props.updateWorkLog(__assign(__assign({}, worklog), { approvedHours: target.value }));
    };
    ProjectWorklogs.prototype.projectTypeOnChange = function (worklog, projectType) {
        this.props.updateWorkLog(__assign(__assign({}, worklog), { projectType: projectType }));
    };
    ProjectWorklogs.prototype.renderProjectRow = function (worklog) {
        var _this = this;
        var rowClass = worklog.approvedHours + worklog.hours === 0 ? 'invalid' : '';
        var operationPermission = this.props.getWorkLogPermission(worklog);
        return (React.createElement("tr", { key: worklog._id, className: rowClass },
            React.createElement("td", { className: "type-column" },
                React.createElement(index_2.Row, null,
                    React.createElement("i", { className: "material-icons location-icon " }, "location_city"),
                    operationPermission.UPDATE && this.props.editable ?
                        React.createElement(projectTypeInput_1.default, { worklog: worklog, projectTypes: this.props.getProjectTypes(worklog), onProjectTypeChanged: function (type) { return _this.projectTypeOnChange(worklog, type); } }) : worklog.projectType ? (worklog.projectType.name || '') : '')),
            React.createElement("td", null, formatter_1.Hour.durationToHourMinuteString(worklog.hours)),
            React.createElement("td", null,
                " ",
                ' - ',
                " "),
            React.createElement("td", null, operationPermission.CONTROL && this.props.editable ?
                React.createElement(index_1.HourInput, { name: "approvedHours", onChange: function (target) { return _this.worklogOnChange(target, worklog); }, value: worklog.approvedHours || 0, displayFormat: function (hours) { return formatter_1.Hour.durationToHourMinuteString(hours); }, required: true }) :
                "".concat(worklog.approvedHours || 0, "u"))));
    };
    ProjectWorklogs.prototype.renderNewWorkLogButton = function () {
        var _this = this;
        return (React.createElement("tbody", null,
            React.createElement("tr", null,
                React.createElement("td", { colSpan: 4 },
                    React.createElement("button", { className: 'new-log-button', onClick: function () { return _this.props.addWorkLog(); } }, "Voeg werkuren toe")))));
    };
    ProjectWorklogs.prototype.render = function () {
        var _this = this;
        var project = this.props.project;
        if (!project) {
            return null;
        }
        var summary = (0, utils_1.getProjectHours)(this.props.worklogs);
        var projectDescriptionLine = "".concat(project.number || '', ": ").concat(project.name || '');
        var projectDescriptionLine2 = "".concat(project.address || '', "\n     ").concat(_.get(project, 'addresses[0].address.city') || '');
        var projectHasNoWorklocations = !project.addresses || !project.addresses.length;
        var projectHasWorklocationWithoutCoords = project.addresses
            && project.addresses.some(function (address) { return (address === null || address === void 0 ? void 0 : address.radius) === 0; });
        return (React.createElement(index_2.Column, { key: project._id },
            React.createElement(index_2.Wrapper, null,
                React.createElement("div", { className: "project-item clickable", onClick: function () { return _this.setState({ expanded: !_this.state.expanded }); } },
                    React.createElement(index_2.Row, { justifyContent: "space-between" },
                        React.createElement(index_2.Row, { flex: 1, alignItems: "center", justifyContent: "space-between" },
                            React.createElement("i", { className: "material-icons project-icon" }, "access_time"),
                            React.createElement(index_2.Column, null,
                                React.createElement("span", { className: "project-name" }, projectDescriptionLine),
                                React.createElement("span", { className: "project-name" }, projectDescriptionLine2)),
                            React.createElement("i", { className: "material-icons expand-icon" }, this.state.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down')))),
                this.state.expanded &&
                    React.createElement("div", null,
                        projectHasNoWorklocations &&
                            React.createElement("div", { className: "alert-container danger" },
                                React.createElement("span", { className: "alert-text" }, "Geen adres gevonden voor deze werklocatie.")),
                        projectHasWorklocationWithoutCoords && !this.props.totalWorkTime &&
                            React.createElement("div", { className: "alert-container danger" },
                                React.createElement("span", { className: "alert-text" }, "Geen kadastrale gegevens voor \u00E9\u00E9n of meerdere adressen voor deze werklocatie gevonden.")),
                        React.createElement("table", { className: "project-table", style: { opacity: this.state.expanded ? 1 : 0 } },
                            React.createElement("tbody", null, this.props.worklogs.map(function (worklog) { return _this.renderProjectRow(worklog); })),
                            this.props.editable && this.props.getProjectTypes().length
                                ? this.renderNewWorkLogButton() : null,
                            this.renderSummary(summary))))));
    };
    return ProjectWorklogs;
}(React.Component));
exports.default = ProjectWorklogs;
